const GOOGLE_ADS_ID = "AW-17957997976";

// Google Ads requiere el "conversion label" para registrar la conversión.
// El ID base ya deja cargada la etiqueta global en toda la app.
const GOOGLE_ADS_CONVERSION_LABEL = "";

type GtagFunction = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: GtagFunction;
  }
}

let googleAdsInitialized = false;
let conversionLabelWarningShown = false;

export const initializeGoogleAds = () => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];

  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  const existingScript = document.querySelector<HTMLScriptElement>(
    `script[data-google-ads-id="${GOOGLE_ADS_ID}"]`
  );

  if (!existingScript) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
    script.dataset.googleAdsId = GOOGLE_ADS_ID;
    document.head.appendChild(script);
  }

  if (!googleAdsInitialized) {
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_ADS_ID);
    googleAdsInitialized = true;
  }
};

export const trackGoogleAdsPageView = (pagePath: string) => {
  if (typeof window === "undefined" || !window.gtag) return;

  window.gtag("config", GOOGLE_ADS_ID, {
    page_path: pagePath,
  });
};

export const trackGoogleAdsConversion = (transactionId?: string) => {
  if (!GOOGLE_ADS_CONVERSION_LABEL) {
    if (!conversionLabelWarningShown) {
      console.warn(
        "Google Ads conversion label is missing. Add it in src/utils/googleAds.ts to send the conversion event."
      );
      conversionLabelWarningShown = true;
    }

    return false;
  }

  if (
    typeof window === "undefined" ||
    !window.gtag
  ) {
    return false;
  }

  const payload: Record<string, string> = {
    send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`,
  };

  if (transactionId) {
    payload.transaction_id = transactionId;
  }

  window.gtag("event", "conversion", payload);
  return true;
};
